<template>
  <el-container style="height: 100vh;">
    <el-container>
      <el-header class="headerWrapper" :style={backgroundColor:activeColor}>
        <div class="logoTextWrapper">
          <router-link to="/home">
            <img width="76" height="36" src="../assets/nibdlogo.png" style="margin-top: 7px;">
          </router-link>
        </div>
        <div class="display">
          <div class="aikeywordBox">
            <el-input class="aikeywordIpt" v-model="listQuery.aikeyword" placeholder="产品编号或名称" clearable
             @keyup.enter.native="handleSearchList">
                <i slot="suffix" class="el-icon-search" @click="handleSearchList"></i>
              </el-input>
          </div>
          <el-menu :default-active="activeIndex" popper-class="menuClass" class="el-menu-demo"  mode="horizontal" @select="handleSelect"
           text-color="#90A4C7" active-text-color="#FFFFFF" :background-color="activeColor">
            <template v-for="(item,index) in menuList">
              <template v-if="item.name != 'login'&& item.activPath != 'home' && item.name != 'chart' && !item.hidden">
                <el-submenu v-if="item.noChildren" :index="item.redirect" :key="index" >
                  <template slot="title">
                    <span :class="[currentIndex==item.activPath ? 'colorActive':'' ]">{{item.meta.title}}</span>
                  </template>
                  <template v-for="(child,index) in item.children">
                    <el-menu-item v-if="!child.hidden" :index="child.path"  :key="child.name"
                    :class="[currentIndex==item.activPath&&currentName== child.name? 'colorActive':'' ]">
                      {{child.meta.title}}
                    </el-menu-item>
                  </template>
                </el-submenu>
                <!-- <el-menu-item v-else :index="item.path+'/'+item.children[0].path"
                 :class="[currentIndex==item.activPath ? 'colorActive':'' ]">
                  <span slot="title">{{item.meta.title}}</span>
                </el-menu-item> -->

                <el-menu-item v-else :index="item.redirect" :key="index" :class="[currentIndex==item.activPath ? 'colorActive':'' ]">
                  <span slot="title">{{item.meta.title}}</span>
                </el-menu-item>
              </template>
            </template>
          </el-menu>

          <notification-bar/>

          <div class="headerRight">
            <el-dropdown class="avatar-container" popper-class="dropdownClass">
              <div class="avatar-wrapper">
                <!-- <img class="user-avatar" :src="avatar"> -->
                <span class="account">{{user}}</span>
                <i class="el-icon-caret-bottom"></i>
              </div>

              <el-dropdown-menu class="user-dropdown" slot="dropdown" popper-class="dropdownClass">
                <router-link :to="{ name: 'c_addressBook'}">
                  <el-dropdown-item class="dropdownItem" command="a">通讯录</el-dropdown-item>
                </router-link>
                <router-link :to="{ name: 'c_memorandum'}">
                  <el-dropdown-item class="dropdownItem" command="b">备忘录</el-dropdown-item>
                </router-link>
                <!-- <router-link :to="{ name: 'c_followRecord'}">
                  <el-dropdown-item class="dropdownItem" command="c">我的跟进</el-dropdown-item>
                </router-link> -->
                <el-dropdown-item class="dropdownItem">
                  <div @click="getInfo">用户信息</div>
                </el-dropdown-item>
                <el-dropdown-item class="dropdownItem">
                  <div @click="getCode">名片二维码</div>
                </el-dropdown-item>
                <el-dropdown-item class="dropdownItem">
                  <div @click="passwordDialog = true">修改密码</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span @click="logout" style="display:block;">退出</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <el-color-picker class="colorPicker" v-model="activeColor" @change="colorChange"></el-color-picker> -->
          </div>
        </div>

      </el-header>
      <el-main class="main">
        <sidebar v-if="$route.meta.sideBar"></sidebar>
        <div :style="{marginLeft:$route.meta.sideBar ? '175px':'0',padding:'0 6px'}">
          <div class="breadcrumbWrapper">
            <breadcrumb></breadcrumb>
            <el-carousel class="tagsCarouselBox" height="22px" direction="vertical" :autoplay="true">
              <el-carousel-item v-for="(item,index) in tipLists" :key="index">
                <div class="giftTipsBox">
                  <div class="giftTips" v-if="item.isClose">
                    <router-link class="giftTips" :to="{ name: item.url,query: item.query}">
                      <div>{{item.con}}</div>
                    </router-link>
                    <div class="closeBox" @click.stop="item.isClose = false"><i class="el-icon-close"></i></div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <router-view></router-view>

        </div>

        <el-dialog title="修改密码" :visible.sync="passwordDialog" width="500px" center>
          <el-form :model="passForm" status-icon :rules="rules" ref="passForm" label-width="80px" class="passFormClass">
            <el-form-item label="新密码" prop="Password1">
              <el-input type="password" v-model="passForm.Password1" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="Password2">
              <el-input type="password" v-model="passForm.Password2" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button style="width: 170px;padding:12px;" @click="passwordDialog = false">取 消</el-button>
            <el-button style="width: 170px;padding:12px;" type="primary" @click="submitForm('passForm')">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="用户信息" :visible.sync="infoDialog" width="800px" center>
          <el-form :model="infoForm" status-icon :rules="rules" ref="infoForm" label-width="90px" class="infoFormClass"  v-loading="infoLoading">
            <div class="left">
              <el-form-item label="手机号码">
                <el-input v-model="infoForm.phone"></el-input>
              </el-form-item>
              <el-form-item label="英文名">
                <el-input v-model="infoForm.english_name"></el-input>
              </el-form-item>
              <el-form-item label="微信号">
                <el-input v-model="infoForm.weixin"></el-input>
              </el-form-item>
              <el-form-item label="邮箱">
                <el-input v-model="infoForm.email"></el-input>
              </el-form-item>
              <el-form-item label="邮箱安全码">
                <el-input v-model="infoForm.MailboxSecurityCode"></el-input>
              </el-form-item>
              <el-form-item label="钉钉标志">
                <el-input v-model="infoForm.dingtalk"></el-input>
              </el-form-item>
            </div>
            <div class="left">
              <el-form-item label="职位">
                <el-input v-model="infoForm.position"></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-radio-group v-model="infoForm.sex">
                  <el-radio-button label="1">男</el-radio-button>
                  <el-radio-button label="2">女</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="照片">
                <!-- <el-input v-model="infoForm.photo"></el-input> -->
                <el-upload
                  class="avatar-uploader"
                  action="/api/Base/upload"
                  :headers="myHeaders"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="infoForm.photo" :src="infoForm.photo" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button style="width: 170px;padding:12px;" @click="infoDialog = false">取 消</el-button>
            <el-button style="width: 170px;padding:12px;" type="primary" @click="submitInfo()">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 二维码 -->
        <el-dialog title="名片二维码" :visible.sync="codeDialog" width="420px" center>
          <div style="text-align: center;" v-html="code_url"></div>
        </el-dialog>

      </el-main>

      <!-- 变更通知 -->
      <need-impart></need-impart>

    </el-container>
  </el-container>
</template>

<script>
  import { routes } from '@/router/index';
  // import { mapGetters } from 'vuex'
  import Breadcrumb from '@/components/Breadcrumb'
  import Sidebar from '@/components/Sidebar'
  import {setCookie,getCookie,removeCookie} from '@/utils/support';
  import { validateURL } from '@/utils/validate';
  import {giftListTips} from "@/api/gift";
  import {orderReminder} from "@/api/order";
  import {changePassword,userDetails,userDataModification} from "@/api/login";
  import NeedImpart from '@/components/NeedImpart';
  const defaultListQuery = {
    vin:null,
    keyword:null,
    aikeyword:null,
    number:null,
    numberlist:null,
  };
  var ls = window.localStorage;
  var token = getCookie("nibdToken"); // 要保证取到

  // var nibd_company_id =  getCookie('nibd_company_id');
import onlyViewMixin from "@/common/mixin/onlyViewMixin.js";
import NotificationBar from "@/components/notificationBar/entry";

  export default {
    mixins: [onlyViewMixin],
    components: {
      Breadcrumb,
      Sidebar,
      NeedImpart,
      NotificationBar
    },
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.passForm.Password2 !== '') {
            this.$refs.passForm.validateField('Password2');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.passForm.Password1) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        activeIndex:'/home',
        // oldActiveIndex:'/home',
        currentIndex:null,
        currentName:null,
        nibdToken:getCookie('nibdToken'),
        oldToken:getCookie('nibdToken'),
        // nibd_company_id:getCookie('nibd_company_id'),
        nibdUser_id:getCookie('nibdUser_id'),
        is_need: getCookie('nibd_isNeed'),
        is_need_purchase: getCookie('nibd_isNeedPurchase'),
        role_id:getCookie('role_id'),
        myHeaders:{Authorization: token},
        // menuList: this.nibd_company_id==2?routes2:routes,
        menuList: routes,
        // menuList:this.nibd_company_id==2?Object.assign({}, defaulMenuList2):Object.assign({}, defaulMenuList1),
        listQuery: Object.assign({}, defaultListQuery),
        currentImg:'',
        user:getCookie('nibd_name'),
        tipLists:[],
        activeColor:ls.getItem("nibd_activeColor")?ls.getItem("nibd_activeColor"):'#172E57',
        passwordDialog:false,
        passForm: {
          Password1: '',
          Password2: '',
        },
        rules: {
          Password1: [
            { validator: validatePass, trigger: 'blur' }
          ],
          Password2: [
            { validator: validatePass2, trigger: 'blur' }
          ],
        },
        infoDialog:false,
        infoLoading:false,
        infoForm:{
          user_id:'',
          sex:1,
          phone:'',
          email:'',
          MailboxSecurityCode:'',
          dingtalk:'',
          position:'',
          english_name:'',
          weixin:'',
          photo:'',
        },
        codeDialog:false,
        code_url:''
      };
    },
    created() {
      this.activeIndex=this.$route.path;
      // this.oldActiveIndex=this.$route.path;
      this.getActiveIndex(this.activeIndex);
      this.Menufilter()
      this.getListTips();
      // this.menuList = this.nibd_company_id==2?routes2:routes;
      // this.menuList = this.nibd_company_id==2?Object.assign({}, defaulMenuList2):Object.assign({}, defaulMenuList1);
      // console.log('menuList',this.menuList)
    },
    mounted() {
      setInterval(() => {
        this.getListTips()
        // console.log('ddddd',this.oldToken,getCookie('nibdToken'),this.oldToken == getCookie('nibdToken'))
        if(this.oldToken == getCookie('nibdToken')){
          return
        }else{
          // window.opener=null;window.close();
          location.reload()
        }
      }, 1000*60);
    },
    // computed: {
    //   ...mapGetters(["activeColor"]),
    // },$route.meta.keepAlive
    watch: {
      $route(newVAL,old){
        this.getCurrentPath()
      },
    },
    methods:{
        //菜单过滤
        Menufilter(){
          if(this.is_need == 1) {
            this.menuList = routes

            if(this.is_need_purchase != 1){
               //过滤掉 采购历史
               this.menuList.forEach(item => {
                if (item.name === 'procure') {
                  item.children = item.children.filter(child => child.name !== 'procureHistory' && child.name !== 'procureHistoryView');
                }
              });
            }
          }else{
              this.menuList = routes
              if(this.is_need_purchase == 1){
                //只显示 '采购历史'
                this.menuList.forEach(item => {
                  if (item.name === 'procure') {
                    item.children = item.children.filter(child => child.name == 'procureHistory' || child.name == 'procureHistoryView');
                  }
                });
              }else{
                 //没有 "需求" 权限
                this.menuList = this.menuList.filter(item => item.name !== 'procure');
              }
          }

          let roleIdList = []
          if(this.role_id.length > 0){
            roleIdList = this.role_id.split(",");
          }

          // 过滤掉 集采分析
          if(!roleIdList.includes("111")){
            this.menuList.forEach(item => {
              if (item.name === 'other') {
                item.children = item.children.filter(child => child.name !== 'collectiveAnalysis');
              }
            });
          }

          // 过滤掉 售后反馈
        if(!roleIdList.includes("134")){
          this.menuList.forEach(item => {
            if (item.name === 'other') {
              item.children = item.children.filter(child => child.name !== 'afterSalesFeedback');
            }
          });
        }

          if(!roleIdList.includes("92")){
            //过滤 销售预测
            this.menuList.forEach(item => {
              if (item.name === 'other') {
                item.children = item.children.filter(child => child.name !== 'SalesForecasting');
              }
            });
          }
          if(!roleIdList.includes("94")){
            //过滤 库存预警
            this.menuList.forEach(item => {
              if (item.name === 'other') {
                item.children = item.children.filter(child => child.name !== 'InventoryWarning');
              }
            });
          }
          if(!roleIdList.includes("101")){
            // 过滤 地区仓库显示
            this.menuList.forEach(item => {
                if (item.name === 'other') {
                  item.children = item.children.filter(child => child.name !== 'areaWarehouse');
                }
            });
          }
          if(!roleIdList.includes("102")){
            //过滤掉 调拨单
            this.menuList.forEach(item => {
                if (item.name === 'other') {
                  item.children = item.children.filter(child => child.name !== 'transfer');
                }
            });
          }
        },
      colorChange(val){
        ls.setItem("nibd_activeColor", val);
      },
      getListTips() {
        this.tipLists = []
        giftListTips().then(res => {
          if (res.data.data) {
            var item={
              url:'gift',
              query:{ status:'0'},
              con:res.data.data,
              isClose:true,
            }
            this.tipLists.push(item)
          }
        });
        orderReminder().then(res => {
          // console.log('res.data.data',res.data.data)
          if (res.data.data) {
            var item={
              url:'billsCP',
              query:{ status:'0'},
              con:res.data.data,
              isClose:true,
            }
            this.tipLists.push(item)
          }
        });
      },
      handleSelect(key, keyPath) {
        // console.log('55',key, keyPath);
        // console.log('66', key,keyPath[0]);
        // var arr = key.split('/')
        //  const { href } = this.$router.resolve({
        //     path: key,
        //   });
        // // console.log('href', href);
        //   // window.open(href, "_blank");

        //   if(key=='/select/cart'){
        //    // 设置跳转
        //   this.openAndSetView(
        //     key+'?parentPath='+this.$route.path,
        //     this.getOnlyView.cart
        //   );
        //   return;
        //   }

        //   if(key=='/bills/billsCP'){
        //    // 设置跳转
        //   this.openAndSetView(
        //     key+'?parentPath='+this.$route.path,
        //     this.getOnlyView.billsCP
        //     );
        //   return;
        //   }
        if (validateURL(key)) {
          this.handleExtraLinkJump(key, keyPath);
          return;
        }
        this.activeIndex=key;
        this.getActiveIndex(keyPath[0]);
        this.$router.push(key);
      },
      getActiveIndex(key){
        // console.log('key',key)
        var arr =key.split("/");
        var lan = arr.length-1
        // if (this.nibd_company_id==2) {
        //   if(arr[lan]=='generateGiftOrder'){
        //     this.currentName = 'gift'
        //     this.currentIndex = 'other'
        //   } else if(arr[lan]=='generateQuotedPriceOrder'){
        //     this.currentName = 'quotedPriceCP'
        //     this.currentIndex = 'quotedPrice'
        //   } else if(arr[lan]=='quotedHistory'){
        //     this.currentName = 'quotedHistory'
        //     this.currentIndex = 'other'
        //   } else if(arr[lan]=='noReturnGoods'||arr[lan]=='materialObject'||arr[lan]=='noMaterialObject'){
        //     this.currentName = 'returnGoods'
        //     this.currentIndex = 'other'
        //   } else{
        //     this.currentIndex = arr[1];
        //   }
        // } else{
        //   if(arr[lan]=='generateGiftOrder'){
        //     this.currentName = 'gift'
        //     this.currentIndex = 'other'
        //   } else if(arr[lan]=='generateQuotedPriceOrder'){
        //     this.currentName = 'quotedPriceCP'
        //     this.currentIndex = 'other'
        //   } else if(arr[lan]=='noReturnGoods'||arr[lan]=='materialObject'||arr[lan]=='noMaterialObject'){
        //     this.currentName = 'returnGoods'
        //     this.currentIndex = 'other'
        //   } else{
        //     this.currentIndex = arr[1];
        //   }
        // }

        if(arr[lan]=='generateGiftOrder'){
          this.currentName = 'gift'
          this.currentIndex = 'other'
        } else if(arr[lan]=='generateQuotedPriceOrder'){
          this.currentName = 'quotedPriceCP'
          this.currentIndex = 'other'
        } else if(arr[lan]=='noReturnGoods'||arr[lan]=='materialObject'||arr[lan]=='noMaterialObject'){
          this.currentName = 'returnGoods'
          this.currentIndex = 'other'
        } else{
          this.currentIndex = arr[1];
        }
        // this.currentIndex = arr[1];
        // console.log('arr',arr,this.currentIndex)
      },
      handleExtraLinkJump(key, keyPath) {
        const menu = this.findMenuItemByPath(this.menuList, key);
        if (menu) {
          if (menu.meta.handleExtraLink) {
            const { query = '', target = '_blank' } = menu.meta.handleExtraLink();
            window.open(menu.path + query, target);
          } else {
            window.open(menu.path, '_blank');
          }
        }
      },
      findMenuItemByPath(menus, path) {
        let menu;
        for (let i = 0; i < menus.length; i++) {
          const menuItem = menus[i];
          if (menuItem.path === path || menuItem.redirect === path) {
            menu = menuItem;
          }

          if (menuItem.children && menuItem.children.length) {
            menu = this.findMenuItemByPath(menuItem.children, path);
            if (menu && menu.path === path) {
              return menu;
            }
          }
        }
        return menu;
      },
      handleSearchList(){
        this.$router.push({path: '/product/productCP',query:{aikeyword:this.listQuery.aikeyword,time:new Date().getSeconds()}})
      },

      goFollow(){
        this.currentImg = 1
        this.$router.push({name:'c_followRecord'})
        // this.$router.push({path: '/customer/c_followRecord'})
      },
      goAddressBook(){
        this.currentImg = 2
        this.$router.push({name:'c_addressBook'})
      },
      goMemorandum(){
        this.currentImg = 3
        this.$router.push({name:'c_memorandum'})
      },
      getCurrentPath(){
        var path = this.$route.path
        // console.log('path',path)
        if(path=='/home'){
          path=''
        }
        this.activeIndex=path
        // this.oldActiveIndex=path
        // if (this.other == 'other') {
        //   this.currentIndex = this.other
        // }else{
        //   this.getActiveIndex(this.activeIndex)
        // }
        this.getActiveIndex(this.activeIndex)
        if (path == '/customer/c_followRecord') {
          this.currentImg = 1
        } else if (path == '/customer/c_addressBook'){
          this.currentImg = 2
        }else if (path == '/customer/c_memorandum'){
          this.currentImg = 3
        }else{
          this.currentImg = 0
        }
      },
      // 退出登录
      logout() {
        // console.log(999)
        removeCookie("nibdToken");
        removeCookie("nibd_company_id");
        removeCookie("nibd_isNeed");
        removeCookie('nibd_isNeedPurchase');
        window.localStorage.removeItem("nibd_partner_id");
        window.localStorage.removeItem("nibd_customerName");
        window.localStorage.removeItem('nibd_Level_id');

        location.reload() // 为了重新实例化vue-router对象 避免bug
        // this.$store.dispatch('LogOut').then(() => {
        //   removeCookie("nibdToken");
        //   location.reload() // 为了重新实例化vue-router对象 避免bug
        // })
      },
      // 修改密码
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            changePassword(this.passForm).then(res => {
              if (res.data.status == 200) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                  duration: 1000,
                  offset:200
                });
                removeCookie("nibdToken");
                location.reload()
              } else {
                // this.$message.error(res.data.msg);
                this.$message({
                  type: "error",
                  message: res.data.msg,
                  duration: 1000,
                  offset:200
                });
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 获取用户信息
      getInfo(){
        this.infoLoading = true
        let params = new URLSearchParams();
        params.append("user_id", this.nibdUser_id);
        userDetails(params).then(res => {
          this.infoLoading = false
          // console.log('res.data.data',res.data.data)
          if(res.data.data){
            this.infoForm = res.data.data;
          }
        });
        this.infoDialog = true
      },
      // 头像修改
      handleAvatarSuccess(res, file) {
        // console.log('file',file,res)
        this.infoForm.photo = res.data;
        // this.infoForm.photo = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        // const isLt1M = file.size / 1024 / 1024 < 1;

        if (!isJPG && !isPNG) {
          this.$message.error('上传头像图片只能是 JPG、PNG格式!');
        }
        // if (!isLt1M) {
        //   this.$message.error('上传头像图片大小不能超过 1MB!');
        // }
        return isJPG || isPNG;
      },
      // 修改用户信息
      submitInfo(){
        // console.log('this.infoForm',this.infoForm)
        userDataModification(this.infoForm).then(res => {
          if (res.data.status == 200) {
            this.$message({
              type: "success",
              message: res.data.msg,
              duration: 1000,
              offset:200
            });
            this.infoDialog = false
          } else {
            // this.$message.error(res.data.msg);
            this.$message({
              type: "error",
              message: res.data.msg,
              duration: 1000,
              offset:200
            });
          }
        });
      },
      // 获取二维码
      getCode(){
        let params = new URLSearchParams();
        params.append("user_id", this.nibdUser_id);
        userDetails(params).then(res => {
          console.log('res.data.data',res.data.data)
          if(res.data.data){
            this.code_url = res.data.data.code_url;
          }
        });
        this.codeDialog = true
      },
    }

  };
</script>

<style scoped lang="scss">

  .breadcrumbWrapper{
    margin-left: -5px;
    background-color: #ECF5FF;
    display: flex;
  }
  .tagsCarouselBox{
    // width: 80%;
    flex: 1;
  }
  .giftTipsBox{
    flex: 1;
    display: flex;
    justify-content: center;
  }
  .giftTips{
    height: 22px;
    line-height: 22px;
    /* background: #FEF0F0; */
    border-radius: 3px;
    color: #F56C6C;
    margin-left: 10px;
    /* width: 500px; */
    padding: 0 10px;
    display: flex;
    justify-content: center;
    font-weight: bold;
  }
  .closeBox{
    cursor: pointer;
    font-weight: bold;
    font-size: 20px;
    margin-left: 10px;
  }
  .colorPicker /deep/ .el-color-picker__trigger{
    padding: 0;
    border: none;
    width: 25px;
    height: 25px;
  }
  .colorPicker{
    margin-left: 10px;
    width: 25px;
    height: 25px;
  }
  .logoTextWrapper{
    font-size: 24px;
    font-family: PangMenZhengDao;
    color: #FFFFFF;
    display: flex;
    justify-content: space-between;
    margin-top: 6px;
  }
  .logoWrapper{
    margin: 20px auto;
    text-align: center;
  }
  .el-menu-item{
    font-size: 14px;
    position: relative;
    padding: 0 13px;
  }
  .colorActive{
    color: #FFFFFF !important;
    /* color: #FFFFFF !important; */
  }
  /* .el-menu-demo /deep/ .el-menu-item.is-active:not(.colorActive){
    color:#90A4C7 !important;
  } */
  .el-menu-demo /deep/ .el-submenu__title,.el-menu-demo>.el-menu-item.is-active{
    font-size: 14px;
    border-bottom: none !important;
    padding: 0 13px;
  }
  .el-menu-demo /deep/ .el-submenu .el-menu-item{
    font-size: 14px;
  }
  .el-menu-demo /deep/ .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
    color: #FFFFFF;
  }
  .user-dropdown{
    background-color:var(--barHeadColor);
    border: none;
    box-shadow: none;
  }
  .user-dropdown .el-dropdown-menu__item{
    color: var(--bartextColor);
  }
  .user-dropdown .popper__arrow,.user-dropdown .el-popper .popper__arrow::after,.el-popper .popper__arrow, .el-popper .popper__arrow::after{
    display: none;
  }
  .user-dropdown .el-dropdown-menu__item:focus, .user-dropdown .el-dropdown-menu__item:not(.is-disabled):hover{
      background-color: inherit;
      color: #FFFFFF;
  }

  .headerWrapper{
    padding: 0px 15px 0px 10px;
    background-color: #1E5FE3;
    height: 50px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    font-size: 14px;
  }
  .headerWrapper /deep/ .el-menu.el-menu--horizontal{
    border-bottom:none;
  }
  .headerWrapper /deep/ .el-menu--horizontal>.el-menu-item,.headerWrapper /deep/ .el-menu--horizontal>.el-submenu .el-submenu__title{
    height: 50px;
    line-height: 50px;
  }
  .aikeywordBox{
    display: flex;
    align-items: center;
    margin-right: 10px;
  }
  .aikeywordIpt{
    width: 220px;
    height: 30px;
  }
  .aikeywordIpt /deep/ .el-input__inner{
    background: #233C69;
    border: 1px solid #A0CFFF;
    border-radius: 3px;
    width: 220px;
    height: 30px;
    line-height: 30px;
    color: #A0CFFF;
    padding-right:25px;
  }
  .aikeywordIpt /deep/ .el-input--suffix{
    line-height: 30px;
  }
  .aikeywordIpt /deep/ .el-input__suffix{
    line-height: 30px;
  }
  .aikeywordIpt /deep/ .el-input__icon{
    line-height: 30px;
  }
  .searchBtn{
    width: 120px;
    height: 40px;
  }
  .headerRight{
    text-align: right;
    display: flex;
    align-items: center;
  }
  .headerRight img{
    margin: 0 12px;
    cursor: pointer;
  }
  .avatar-wrapper{
    cursor: pointer;
    color: #FFFFFF;
  }
  .account {
    font-size: 14px;
    margin-left: 15px;
    margin-right: 6px;
  }
  .main{
    padding: 0;
    /* padding-left: 10px; */
  }

.badgeItem /deep/ .el-badge__content{
  line-height: 16px;
}

.infoFormClass{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left{
  width: 45%;
}

.avatar-uploader /deep/ .el-upload{
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader /deep/  .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 182px;
  height: 182px;
  line-height: 182px;
  text-align: center;
}
.avatar {
  width: 182px;
  height: 182px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/view/admin.vue